import React from "react";
import { useLocation } from "react-router-dom";
import "./HeaderStyles.css";
import usuario from "../../assets/usuario.png";
import { UserAuth } from "../../context/AuthContext";

const Header = () => {
  const { userEmail } = UserAuth();
  const location = useLocation();
  //Mapeo de rutas
  const routeMappings = {
    dashboard: "Dashboard",
    emociones: "Emociones",
  };
  //Funcion para capitalizar la primera letra de la palabra y manejar caracteres especificas
  const formatSegment = (segment) => {
    const decodedSegment = decodeURIComponent(segment);
    return (
      routeMappings[decodedSegment.toLowerCase()] || // Mapeo a texto o capitalización por defecto
      decodedSegment.charAt(0).toUpperCase() + decodedSegment.slice(1)
    );
  };
  //Función para crear la ruta dinamica
  const createNavigationPath = (path) => {
    const pathSegments = path.split("/").filter(Boolean).map(formatSegment);
    return `Home / ${pathSegments.join(" / ")}`;
  };
  const navigationPath = createNavigationPath(location.pathname);
  return (
    <div className="flex justify-between p-4">
      <div className="">
        <h1 className="text-xl font-bold text-left xl:text-3xl text-blue-950">
          Dashboard
        </h1>
        <p className="mx-auto text-base">{navigationPath}</p>
      </div>
      <div className="relative flex items-center">
        <img
          src={usuario}
          alt="Usuario"
          className="z-10 object-cover w-10 bg-white rounded-full h-01 xl:w-12 xl:h-12"
        />
        <div className="px-6 py-2 bg-white rounded-full shadow-lg ml-[-31px] z-0">
          <p className="w-40 h-[23px] text-sm font-medium text-gray-800">
            {userEmail}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
